import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import _VaFileUploadListItem from './VaFileUploadListItem.vue'

export const VaFileUploadListItem = withConfigTransport(_VaFileUploadListItem)
